export const SET_ONTOLOGY_SUCCESS = 'ontology/SET_ONTOLOGY_SUCCESS';
export const SET_LABELS_SUCCESS = 'ontology/SET_LABELS_SUCCESS';
export const SET_CONCEPTS_COUNT = 'ontology/SET_CONCEPTS_COUNT';
export const SET_LANGUAGES = 'ontology/SET_LANGUAGES';
export const SET_SELECTED_LANGUAGE = 'ontology/SET_SELECTED_LANGUAGE';
export const SET_UPDATE_INTERVAL = 'ontology/SET_UPDATE_INTERVAL';
export const SET_ALERT_TIMELINE = 'ontology/SET_ALERT_TIMELINE';
export const SET_SHOW_AGENT_NAMES = 'ontology/SET_SHOW_AGENT_NAMES';
export const SET_HIDE_OLD_AGENTS = 'ontology/SET_HIDE_OLD_AGENTS';
export const SET_SHOW_INACTIVE_AGENTS = 'ontology/SET_SHOW_INACTIVE_AGENTS';
export const SET_SHOW_OBSERVATION_CLUSTERS =
  'ontology/SET_SHOW_OBSERVATION_CLUSTERS';
export const SET_OBSERVATION_CLUSTER_THRESHOLD =
  'ontology/SET_OBSERVATION_CLUSTER_THRESHOLD';
export const SET_SHOW_OBSERVATION_HEATMAP =
  'ontology/SET_SHOW_OBSERVATION_HEATMAP';
export const SET_SHOW_TRACK_HEATMAP = 'ontology/SET_SHOW_TRACK_HEATMAP';
export const SET_SHOW_TRACK_FULL_STANDARD =
  'ontology/SET_SHOW_TRACK_FULL_STANDARD';
export const SET_SHOW_TRACK_FULL_COLOUR = 'ontology/SET_SHOW_TRACK_FULL_COLOUR';
export const SET_OBSERVATION_HEATMAP_RESOLUTION =
  'ontology/SET_OBSERVATION_HEATMAP_RESOLUTION';
export const SET_TRACK_HEATMAP_RESOLUTION =
  'ontology/SET_TRACK_HEATMAP_RESOLUTION';
export const SET_OBSERVATION_HEATMAP_OPACITY =
  'ontology/SET_OBSERVATION_HEATMAP_OPACITY';
export const SET_TRACK_HEATMAP_OPACITY = 'ontology/SET_TRACK_HEATMAP_OPACITY';
export const SET_TRACK_COLOR = 'ontology/SET_TRACK_COLOR';
export const SET_SHOW_GRID = 'ontology/SET_SHOW_GRID';
export const SET_SHOW_COORDINATES = 'ontology/SET_SHOW_COORDINATES';
